<template>
<widget title="My Services" 
	icon="fa-wrench" 
	max-height="400px" 
	:widget-spinner="widgetSpinner" 
	:max-height="maxHeight"
	header-button="fa-external-link-alt"
	v-on:headerButtonClick="$router.push('/services/mine')">

	<table-list
		record-name="Service"
		:fields="fields"
		:records="services"
		:hide-record-count="true"
		:sortable="true"
		:clickable-row="true"
		edit-button-text="Open"
		id-field="slug"
		has-edit="/service/{?}/dashboard"
		>
	</table-list>
</widget>
</template>
<script type="text/javascript">
import Widget from "@/components/Widget"
import TableList from "@/components/TableList"

export default {
	name: "MyServicesWidget",
	components: {
		Widget,
		TableList
	},
	props: ["maxHeight"],
	data() {
		return {
			services: [],
			fields: [
				{label: "#",key:"job_num"},
				{label: "Name",key:"job_name"}
			],
			widgetSpinner: false
		}
	},
	methods: {
		fetchData() {
			let vm = this

			let params = {
				include: [
					{
						model: "User",
						fields: ["id","slug","first_name","last_name","last_active"]
					},
					{
						model: "ServiceInvoice",
						fields: ["id","slug","quote_status","is_quote","finalized"]
					}
				],
				orders: [
					['due_date',"DESC"],
					['appointment_time',"DESC"],
					["job_num","DESC"]
				]
			}

			this.widgetSpinner = true

			this.getJSON("Service/my-list",params).then(response => {
				vm.services = response.data
				vm.widgetSpinner = false
			})
		}
	},
	created() {
		this.fetchData()
	}
}
</script>